import React from 'react';
import { useEffect, useState } from "react";
import { getAllData, postUsersData, patchUsersData, verifytoken, deleteUserData } from '../../../services/ApiCallingUserServices';
import Switch from 'react-switch';
import { formatDate, generatePDF, getDateCombination, isImageValidPng } from '../../commonClass/CommonValidation'
import { CommonFileURLWithFolder, ImageDelete, ImageUpload } from '../../../ImageUpload/ImageCommon';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage } from '../../commonClass/Session';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ExportExcel } from '../../commonClass/ExportExcel';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import CustomSelection from '../../../customControl/CustomSelection';
import CustomTable from '../../../customControl/CustomTable';
import CommonFilter from '../../../customControl/CommonFilter';

const Gallerymaster = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const inputRef = useRef();

    const [modalShow, setModalShow] = useState(false);

    const [editdisabled, setEditDisabled] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");

    const [gallaryalllocation, setGallayAllLocation] = useState([]);
    const [themelistdate, setThemeListData] = useState([]);

    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState('All');
    const [searchDisabled, setSearchDisable] = useState(false);

    const [citydisable, setCityDisable] = useState(false);
    const [themedisable, setThemeDisable] = useState(false)
    const [allCity, setallCity] = useState([]);
    const [alltheme, setallTheme] = useState([]);

    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    const [stateName, setStateName] = useState("");

    const [gallerylistdata, setGalleryListData] = useState([]);
    const [filterList, setFilterList] = useState([]);

    const [formValue, setFormValue] = useState({
        GalleryId: 0,
        ImageDisplayName: '',
        ImageList: [],
        LocationId: 0,
        ThemeId: 0,
        IsActive: false
    });
    const [formErrors, setFormErrors] = useState(null);

    const [onImageHover, setOnImageHover] = useState(0);

    //#region handle rights
    useEffect(() => {
        if (user?.length > 0) {
            const pathName = window?.location?.pathname?.toLowerCase();
            const hasRights = user?.find(x => x?.PageLink?.toLowerCase() === pathName)
            if (!hasRights?.URightView) {
                navigate("/dashboard");
                return;
            }
            setUserAdd(hasRights?.URightAdd);
            setUserEdit(hasRights?.URightEdit);
            setUserExport(hasRights?.URightExport);
        }
    }, [user])
    //#endregion

    //#region Calling APIs
    const getGalleryDataList = async () => {
        const gallerylistdata = await getAllData("/master/v1/getallgallery");
        if (gallerylistdata?.status) {
            gallerylistdata?.data?.map((obj) => {
                obj.IsActiveFormat = obj?.isActive ? 'Active' : 'InActive';
                obj.CreatedDateFormat = formatDate(obj?.createdDate);
                return obj;
            })
            setGalleryListData(gallerylistdata?.data ? gallerylistdata?.data : []);
            setFilterList(gallerylistdata?.data ? gallerylistdata?.data : []);
        }
        else {
            setGalleryListData([]);
            setFilterList([]);
        }
    }

    //#region location API
    const getalllocationData = async () => {
        await getAllData('/master/v1/getgallerycity').then((getalllocation) => {
            if (getalllocation?.status) {
                getalllocation?.data?.map((obj) => {
                    obj.label = obj?.city
                    obj.value = obj?.locationId
                    return obj;
                })
                setallCity(getalllocation?.data ? getalllocation?.data : []);
                setGallayAllLocation(getalllocation?.data?.filter(IsAct => IsAct.isActive === true) || []);
            }
            else {
                setallCity([]);
                setGallayAllLocation([]);
            }
        });

    }
    //#endregion

    //#region theme API
    const getthemelistdata = async () => {
        const themelistdata = await getAllData('/master/v1/getgallerytheme');
        if (themelistdata?.status) {
            setThemeListData(themelistdata?.data ? themelistdata?.data?.filter(IsAct => IsAct.isActive === true) : []);
            setallTheme(themelistdata?.data ? themelistdata?.data : []);
        }
        else {
            setThemeListData([]);
            setallTheme([]);
        }
    }

    const themelist = themelistdate?.map(value => ({
        label: value?.themeName,
        value: value?.themeId
    }));
    //#endregion

    useEffect(() => {
        async function fetchData() {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                Promise.allSettled([
                    getthemelistdata(),
                    getalllocationData(),
                    getGalleryDataList()
                ]).then().catch((error) => console.error(error))
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
                dispatch(loaderActions.end());
            }
        }
        fetchData();
    }, [])
    //#endregion


    //#region columns
    const columns = [
        {
            name: 'City',
            key: "city",
            sortable: true,
            reorder: true,
            float: "left",
            selector: (data) => data?.city
        },
        {
            name: 'State',
            key: "stateName",
            sortable: true,
            reorder: true,
            float: "left",
            selector: (data) => data?.stateName
        },
        {
            name: 'Image Name',
            key: "imageDisplayName",
            sortable: true,
            reorder: true,
            float: "left",
            selector: (data) => data?.imageDisplayName
        },
        {
            name: 'Theme Name',
            key: "themeName",
            sortable: true,
            reorder: true,
            float: "left",
            selector: (data) => data?.themeName
        },
        {
            name: 'Active',
            key: "IsActiveFormat",
            sortable: true,
            float: "left",
            selector: (data) => data?.IsActiveFormat
        },
        {
            name: 'Created Date',
            key: "CreatedDateFormat",
            sortable: true,
            reorder: true,
            float: "left",
            selector: (data) => new Date(data?.createdDate),
            format: (data) => data?.CreatedDateFormat,
        },
        {
            name: 'Edit',
            selector: (data) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditViewMode("Edit", data?.galleryId)}></i></button>
        },
        {
            name: 'View',
            selector: (data) => <button type='button' className='border-0 p-0 bg-body set_disableclr'><i className="fa fa-eye" onClick={() => handleEditViewMode("View", data?.galleryId)}></i> </button>
        }
    ];
    //#endregion

    //#region retrieve data on edit & view 
    const handleEditViewMode = (type, id) => {
        setDisabled(type === "Edit" ? false : true);
        setEditDisabled(true);
        setSearchDisable(true);
        setButtonAddEditText(type === "Edit" ? "Update" : "Add");
        RetriveData(id);
    }

    const RetriveData = (id) => {
        setFormErrors(null);
        document.getElementById("txtgalleryimages").value = "";
        const retrieveItem = gallerylistdata?.find(item => item?.galleryId === id) || null;
        if (retrieveItem !== null) {
            const imageList = retrieveItem?.imageList?.map((item) => {
                item.GalleryMasterImageId = item?.galleryMasterImageId;
                item.ImageFileName = item?.imageFileName;
                item.ImagePath = item?.imagePath;
                return item;
            })
            setFormValue((prev) => ({
                ...prev,
                GalleryId: retrieveItem?.galleryId,
                ImageDisplayName: retrieveItem?.imageDisplayName,
                LocationId: retrieveItem?.locationId,
                ImageList: imageList,
                ThemeId: retrieveItem?.themeId,
                IsActive: retrieveItem?.isActive,
            }))
            const allcitylist = allCity?.filter(IsAct => IsAct?.isActive === true);
            setGallayAllLocation(allCity?.filter(IsAct => IsAct?.isActive === true));
            setCityDisable(false);
            if (!allcitylist?.find(IsCity => IsCity?.locationId === retrieveItem?.locationId)) {
                setCityDisable(true)
                setGallayAllLocation((prvCityData) => prvCityData?.length > 0 ? [...prvCityData, allCity?.find(isCity => isCity?.locationId === retrieveItem?.locationId)] : [])
            }

            const allthemelist = alltheme?.filter(IsAct => IsAct?.isActive === true);
            setThemeListData(alltheme?.filter(IsAct => IsAct?.isActive === true));
            setThemeDisable(false);
            if (!allthemelist?.find(IsCity => IsCity?.themeId === retrieveItem?.themeId)) {
                setThemeDisable(true)
                setThemeListData((prvCityData) => prvCityData?.length > 0 ? [...prvCityData, alltheme?.find(isCity => isCity?.themeId === retrieveItem?.themeId)] : [])
            }
            setStateName(retrieveItem?.stateName);
        }
    }
    //#endregion


    //#region handle  chnage functions
    const handleOnChange = (name, value) => {
        setEditDisabled(false);
        setFormErrors(null);

        if (name === "LocationId") {
            setFormValue((prev) => ({ ...prev, LocationId: value?.locationId ? value?.locationId : 0 }));
            setStateName(value?.stateName ? value?.stateName : "");
        }
        else {
            setFormValue((prev) => ({ ...prev, [name]: value }));
        }
    }

    const handleUploadImageLoad = (e) => {
        setFormErrors(null);
        setEditDisabled(false);
        const files = e?.target?.files;
        const newFiles = Object.entries(files)?.map((obj) => obj.pop(0))?.filter((file) => isImageValidPng(file?.name));
        if (files?.length !== newFiles?.length) {
            let error = {};
            error.GalleryImage = 'Only PNG file type is accepted.'
            setFormErrors(error);
        }
        const imageList = newFiles?.reduce((acc, file) => {
            const filename = getDateCombination(file?.name);
            acc.push({
                GalleryMasterImageId: 0,
                ImageFileName: filename,
                ImagePath: `CMS/Gallery/${filename}`,
                Path: `CMS/Gallery/`,
                File: file,
                needToUpload: true,
                uploaded: false,
            });

            return acc;
        }, []);
        setFormValue((prev) => ({ ...prev, ImageList: [...prev?.ImageList, ...imageList] }));
    }

    const handleisActive = (e) => {
        if (buttonaddeditText === 'Add') {
            setFormValue((form) => ({ ...form, IsActive: e }))
            setFormErrors(null);
            setEditDisabled(false);
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            setFormValue((form) => ({ ...form, IsActive: !formValue?.IsActive }))
            setEditDisabled(false);
            setFormErrors(null);
        }
        setModalShow(false);
    }
    //#endregion

    //#region clear handling
    const handleClearClick = () => {
        setFormErrors(null);
        setFormValue({ ...formValue, GalleryId: 0, ImageDisplayName: '', ImageList: [], LocationId: 0, ThemeId: 0, IsActive: false });
        setStateName("");
        setGallayAllLocation([]);
        setSerachBy('All');
        setSearchValue('');
        setSearchDisable(false);
        setDisabled(false);
        setEditDisabled(false);
        getGalleryDataList();
        setButtonAddEditText('Add');
        setCityDisable(false);
        setThemeDisable(false);
        document.getElementById("txtgalleryimages").value = "";
    }
    //#endregion

    //#region validate function
    const validateData = () => {
        let status = true;
        let error = {};
        if (formValue?.LocationId <= 0 || !formValue?.LocationId) {
            error.CityInputId = "Please select city";
        }

        if (formValue.ImageDisplayName?.trim()?.length <= 0 || !formValue.ImageDisplayName) {
            error.ImageDisplayName = "Please enter Group Album Name";
        }
        if (formValue.ImageDisplayName?.trim()?.length > 50) {
            error.ImageDisplayName = "Maximum length is 50 characters";
        }

        if (formValue?.ThemeId <= 0 || !formValue?.ThemeId) {
            error.ThemeInputId = "Please select theme";
        }
        if (formValue?.ImageList?.length <= 0) {
            error.GalleryImage = "Only PNG file type is accepted.";
        }

        const isDuplicate = gallerylistdata?.filter(item =>
            item?.galleryId !== formValue?.GalleryId
            && item?.imageDisplayName?.trim()?.toLowerCase() === formValue?.ImageDisplayName?.trim()?.toLowerCase()
            && item?.locationId === formValue?.LocationId
            && item?.themeId === formValue?.ThemeId
        );

        if (isDuplicate?.length > 0) {
            error.isDuplicate = "You can not enter duplicate value.";
        }

        setFormErrors(error);

        if (Object.keys(error)?.length > 0) {
            status = false;
            const id = Object.keys(error)?.[0];
            document.getElementById(id)?.focus();
        }

        return status;
    }
    //#endregion

    //#region handle add & edit
    const handleSubmitData = async () => {
        if (validateData()) {
            const uploadedFiles = formValue?.ImageList?.filter((item) => item?.needToUpload) || [];
            const payload = {
                ...formValue,
                ImageList: uploadedFiles
            }
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                const insertupdategallary = buttonaddeditText === 'Add' ?
                    await postUsersData("/master/v1/insertgallery", payload)
                    :
                    await patchUsersData("/master/v1/updategallery", payload);

                if (insertupdategallary?.status) {
                    await Promise.allSettled(
                        uploadedFiles?.map(async (ele) => {
                            if (ele?.needToUpload) {
                                try {
                                    const uploaded = await ImageUpload(ele?.Path, ele?.ImageFileName, ele?.File);
                                    ele.uploaded = uploaded;
                                } catch (error) {
                                    console.error(`Error Upload Image: ${error}`)
                                    dispatch(loaderActions.end())
                                }
                            }
                            return ele;
                        })
                    );

                    handleClearClick();
                    getGalleryDataList().then(() => {
                        dispatch(loaderActions.end())
                        dispatch({ type: 'ALERTING', message: insertupdategallary?.message })
                    });
                }
                else {
                    dispatch({ type: 'ALERTING', message: insertupdategallary?.message });
                    dispatch(loaderActions.end());
                }
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
    }
    //#endregion

    //#region delete file function & API
    const handleDeleteFile = (indexId, GalleryMasterImageId) => {
        setFormErrors(null);
        if (GalleryMasterImageId === 0) {
            setFormValue((prev) => ({ ...prev, ImageList: prev?.ImageList?.filter((item, index) => index !== indexId) }));
        }
        else {
            deleteimagebygallerymasterimageid(GalleryMasterImageId);
        }
    }

    const deleteimagebygallerymasterimageid = async (GalleryMasterImageId) => {
        dispatch(loaderActions.start())
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const deleteData = await deleteUserData(`/master/v1/deleteimagebygallerymasterimageid?galleryMasterImageId=${GalleryMasterImageId}`)
            if (deleteData?.status) {
                const deleteImage = formValue?.ImageList?.find((item) => item?.GalleryMasterImageId === GalleryMasterImageId);
                try {
                    const deleted = await ImageDelete(deleteImage?.ImagePath);
                    if (deleted) {
                        setFormValue((prev) => ({ ...prev, ImageList: prev?.ImageList?.filter((item) => item?.GalleryMasterImageId !== GalleryMasterImageId) }));
                        getGalleryDataList().then(() => {
                            dispatch(loaderActions.end())
                            dispatch({ type: 'ALERTING', message: deleteData?.message })
                        });
                    }
                } catch (error) {
                    console.error(`Error Delete Image: ${error}`)
                }
            }
            else {
                dispatch(loaderActions.end())
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end())
        }

    }
    //#endregion

    //#region PDF and Excel Export
    function PdfExport() {
        const keys = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        const pdfColumns = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const rows = gallerylistdata?.map((obj) => keys?.map((key) => obj[key]));
        generatePDF(pdfColumns, rows, "GalleryMaster", "Gallery Master");
    }
    const ExportToExcel = () => {
        const dispalyname = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const fields = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        ExportExcel(dispalyname, fields, gallerylistdata, "GalleryMaster", "GalleryMaster.xls");
    }
    //#endregion

    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>Gallery Master</h3>
            </div>
            <div className="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div className="mb-3 row mx-1">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="row">
                                {formErrors?.isDuplicate && <div className="text-danger fs_14 pb-3 text-center"> {formErrors?.isDuplicate} </div>}
                                <div className='col-md-6 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="CityInputId" className="col-form-label required">Select City</label>
                                        </div>
                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <CustomSelection
                                                inputId="CityInputId"
                                                datalist={gallaryalllocation}
                                                fieldid={formValue?.LocationId}
                                                SelectionChange={(e) => handleOnChange("LocationId", e ? e : 0)}
                                                isdisable={disabled}
                                                isactivedisable={citydisable}
                                                issearchable={true}
                                            />
                                            {formErrors?.CityInputId && <div className="text-danger fs_14"> {formErrors?.CityInputId} </div>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="statename" className="col-form-label">State</label>
                                        </div>
                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <input
                                                type='text'
                                                className='form-control'
                                                id='statename'
                                                value={stateName}
                                                onChange={() => { }}
                                                disabled
                                                placeholder='State'
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="ImageDisplayName" className="col-form-label required">Enter Group Album Name</label>
                                        </div>
                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <input type="text" id="ImageDisplayName" className="form-control"
                                                name="ImageDisplayName"
                                                value={formValue?.ImageDisplayName}
                                                onChange={(e) => handleOnChange("ImageDisplayName", e?.target?.value)}
                                                disabled={disabled ? true : false}
                                                placeholder="Enter Group Album Name"
                                            />
                                            {formErrors?.ImageDisplayName && <div className="text-danger fs_14"> {formErrors?.ImageDisplayName} </div>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="ThemeInputId" className="col-form-label required">Theme</label>
                                        </div>
                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <CustomSelection
                                                inputId="ThemeInputId"
                                                datalist={themelist}
                                                fieldid={formValue?.ThemeId}
                                                SelectionChange={(e) => handleOnChange("ThemeId", e?.value ? e?.value : 0)}
                                                isdisable={disabled}
                                                isactivedisable={themedisable}
                                                issearchable={true}
                                            />
                                            {formErrors?.ThemeInputId && <div className="text-danger fs_14"> {formErrors?.ThemeInputId} </div>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12">
                                            <label htmlFor="inputPassword6" className="col-form-label required">Upload Image</label>
                                        </div>
                                        <div className="col-lg-8 col-md-12 col-sm-12 mb-lg-1 mb-md-1">
                                            <div className="input-group">
                                                <input
                                                    ref={inputRef}
                                                    name='GalleryImage'
                                                    type="file"
                                                    id="txtgalleryimages"
                                                    multiple
                                                    onChange={handleUploadImageLoad}
                                                    className="form-control btn_add"
                                                    accept=".png"
                                                    disabled={disabled ? true : false}
                                                />
                                                <label className="input-group-text" htmlFor="txtgalleryimages">Browse</label>
                                            </div>
                                            {formErrors?.GalleryImage && <div className="text-danger fs_14"> {formErrors?.GalleryImage} </div>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="active" className="col-form-label">Active</label>
                                        </div>
                                        <div className="col-auto col-lg-8">

                                            <Switch
                                                onChange={handleisActive}
                                                checked={formValue?.IsActive}
                                                className="react-switch"
                                                disabled={disabled ? true : false}
                                            />
                                        </div>
                                        <ConfirmationModal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            noconfirm={() => handleConfirmation(false)}
                                            yesconfirm={() => handleConfirmation(true)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className='imageGridBox'>
                                {
                                    formValue?.ImageList?.map((imgItem, index) => (
                                        <div key={imgItem?.ImageFileName + index} className='position-relative'
                                            onMouseEnter={() => setOnImageHover(index + 1)}
                                            onMouseLeave={() => setOnImageHover(0)}
                                            onTouchStart={() => setOnImageHover(index + 1)}
                                            onTouchEnd={() => setOnImageHover(0)}
                                        >
                                            <img
                                                src={
                                                    imgItem?.needToUpload ?
                                                        URL.createObjectURL(imgItem?.File) :
                                                        `${CommonFileURLWithFolder}${imgItem?.ImagePath}`
                                                }
                                                loading='lazy'
                                                className="w-100"
                                                alt={imgItem?.ImageFileName}
                                                width={"200px"}
                                                height={"200px"}
                                                aspect-ratio={3 / 2}
                                            />

                                            {
                                                (!disabled && onImageHover === index + 1) &&
                                                <>
                                                    <div key={index + 1} className="imageGrid_image_hover position-absolute rounded-pill py-1 text-center align-content-center">
                                                        <button type='button' className='btn p-0'
                                                            onClick={() => handleDeleteFile(index, imgItem?.GalleryMasterImageId)}
                                                        >
                                                            <i className="fa-solid fa-trash-can mx-1" />
                                                        </button>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        <button type="button" className="btn btn-primary mx-1" disabled={disabled || editdisabled || (buttonaddeditText === "Add" ? !useradd : !useredit)} onClick={() => handleSubmitData()}> {buttonaddeditText} </button>
                        <button type="button" className="btn btn-primary mx-1" onClick={() => handleClearClick()} >Clear</button>
                    </div>

                    <CommonFilter
                        columns={columns}
                        filterList={filterList}
                        searchDisabled={searchDisabled}
                        getdata={getGalleryDataList}
                        setlistdata={setGalleryListData}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={gallerylistdata}
                        PdfExport={PdfExport}
                        ExportToExcel={ExportToExcel}
                        disabled={!userexport}
                    />
                </form>
            </div>
        </>
    )
}

export default Gallerymaster